import { useEffect } from 'react';

const useOnMount = (callback: VoidFunction): void => {
  useEffect(callback, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useOnMount;
